import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import {
  COUPON_USE_STATUS_OPTION,
  COLOR_COUPON_USE_STATUS,
  LIST_AGENCY_OPTION,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import CollapseFilter from "components/Common/CollapseFilter";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalPreview from "components/Common/ModalPreview";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import avatar1 from "../../../assets/images/users/ic_defaul_avatar2.png";
import agencyApi from "api/agencyApi";
import ModalPreviewQRCode from "components/Common/ModalPreviewQRCode";
import DropdownAsyncBars from "components/Common/DropdownAsyncBars";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import DropdownAsyncAgency from "components/Common/DropdownAsyncAgency";
import DropdownAsyncCampaign from "components/Common/DropdownAsyncCampaign";
import BarListDetail from "pages/BarList/BarListDetail";
import { getCouponList } from "store/coupon/thunk";
import CoundownTime from "components/Common/CoundownTime";
import { capitalizeFirstLetter, truncate } from "utils";
import CopyWrapper from "components/Common/CopyWrapper";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const CouponIssue = () => {
  const { t, i18n } = useTranslation();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    bar_id: withDefault(StringParam, ""),
    linked_user_id: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    agency_id: withDefault(StringParam, ""),
    campaign_id: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    is_not_belong_agency: withDefault(StringParam, ""),
    // sort_by: withDefault(StringParam, "created_at"),
    // order_by: withDefault(StringParam, "DESC"),
  });

  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [previewQRCode, setPreviewQRCode] = useState<any>(null);
  const [itemToBarDetail, setItemToBarDetail] = useState<any>(null);

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.keyword || ""
  );
  const [barSearch, setBarSearch] = useState<any>({
    label: t("All Filter"),
    value: "",
  });
  const [userUsedSearch, setUserUsedSearch] = useState<any>({
    label: t("All Filter"),
    value: "",
  });
  const [agencySearch, setAgencySearch] = useState<Option | any>(
    LIST_AGENCY_OPTION?.find((item) => item?.value === query?.agencyId)
      ?.value || {
      label: t("All Filter"),
      value: "",
    }
  );
  const [campaignSearch, setCampaignSearch] = useState<Option | any>(
    LIST_AGENCY_OPTION?.find((item) => item?.value === query?.campaignId)
      ?.value || {
      label: t("All Filter"),
      value: "",
    }
  );

  const [statusSearch, setStatusSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_OPEN_STATUS?.find(
      (item) => item?.value === query?.status
    )?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Coupon;
  const CouponProperties = createSelector(selectLayoutState, (state) => ({
    lstCoupon: state.lstCoupon,
    isCouponLoading: state.isCouponLoading,
    isCouponSuccess: state.isCouponSuccess,
    error: state.error,
  }));

  // Inside your component
  const { lstCoupon, isCouponLoading } = useSelector(CouponProperties);

  function loadTableData() {
    dispatch(getCouponList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      keyword: keywordSearch,
      bar_id: barSearch?.value !== "all" ? barSearch?.value : "",
      linked_user_id:
        userUsedSearch?.value !== "all" ? userUsedSearch?.value : "",
      status: statusSearch,
      campaign_id: campaignSearch?.value !== "all" ? campaignSearch?.value : "",
      ...(agencySearch?.value === "not"
        ? { is_not_belong_agency: 1 }
        : {
            agency_id: agencySearch?.value !== "all" ? agencySearch?.value : "",
          }),
      // start_date: startDate
      //   ? moment(new Date(startDate)).startOf("day").format("Y-MM-DD HH:mm:ss")
      //   : "",
      // end_date: endDate ? moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss") : "",
      start_date: startDate
        ? formatDateStringToUTC(
            moment(new Date(startDate))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      end_date: endDate
        ? formatDateStringToUTC(
            moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        bar_id: "",
        linked_user_id: "",
        status: "",
        agency_id: "",
        campaign_id: "",
        start_date: "",
        end_date: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setKeywordSearch((_prev) => "");
    setBarSearch({
      label: t("All Filter"),
      value: "",
    });
    setUserUsedSearch({
      label: t("All Filter"),
      value: "",
    });
    setStatusSearch((_prev: any) => "");
    setAgencySearch({
      label: t("All Filter"),
      value: "",
    });
    setCampaignSearch({
      label: t("All Filter"),
      value: "",
    });
    setDateSearch([null, null]);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: "60px" }}>
              {lstCoupon?.summary?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Use Status"),
        accessor: "status",
        thWidth: 180,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_COUPON_USE_STATUS[cell?.value] || "secondary"
                }`}
              >
                {t(
                  COUPON_USE_STATUS_OPTION?.find(
                    (item: any) => item?.value == cell?.value
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Coupon Code"),
        accessor: "code",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          return (
            <>
              <div style={{ minWidth: 100 }}>{cell?.value}</div>
            </>
          );
        },
      },
      {
        Header: t("Issue Date"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Expire Date"),
        accessor: "expires_at",
        filterable: true,
        sortable: false,
        thWidth: 200,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const endDate = formatDateStringToKorea(item?.expires_at);

          return cell?.value ? (
            <div className="text-end" style={{ minWidth: "180px" }}>
              <CoundownTime expireDate={endDate} type="coupon" />
            </div>
          ) : (
            ""
          );
        },
      },
      {
        Header: t("User Used"),
        accessor: "linked_user",
        filterable: true,
        thClass: "whitespace-nowrap",
        sortable: false,
        thWidth: 300,
        Cell: (cell: any) => {
          const item = cell?.value;

          return (
            item && (
              <div
                className="d-flex align-items-center gap-2"
                style={{ minWidth: "175px" }}
                key={item?._id}
              >
                <div
                  style={{
                    height: "35px",
                    width: "35px",
                    overflow: "hidden",
                    borderRadius: "15px",
                    backgroundColor: "#eaeaea",
                    minWidth: "35px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src={item?.userProfile?.profile_image_url || avatar1}
                    alt={item?.userProfile?.nickname}
                    height={35}
                    width={35}
                    className="me-2"
                    style={{
                      overflow: "hidden",
                      borderRadius: "50%",
                      objectFit: "cover",
                      backgroundColor: "#eaeaea",
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = avatar1;
                    }}
                  />
                </div>
                <div>
                  {`${item?.userProfile?.nickname}`} <br />
                  {item?.email}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Store Name"),
        accessor: "bar",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: "150",
        Cell: (cell: any) => {
          const row = cell?.row?.original;
          return (
            row?.bar && (
              <>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setItemToBarDetail(row?.bar);
                  }}
                  style={{
                    width: "150px",
                    color: "#009ef7",
                  }}
                >
                  {row?.bar?.title}
                </div>
              </>
            )
          );
        },
      },
      {
        Header: t("Confirm Bar User"),
        accessor: "cofirmed_user",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.value;

          return (
            item && (
              <div
                className="d-flex align-items-center gap-2"
                style={{ minWidth: "175px" }}
                key={item?._id}
              >
                <div
                  style={{
                    height: "35px",
                    width: "35px",
                    overflow: "hidden",
                    borderRadius: "15px",
                    backgroundColor: "#eaeaea",
                    minWidth: "35px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src={item?.userProfile?.profile_image_url || avatar1}
                    alt={item?.userProfile?.nickname}
                    height={35}
                    width={35}
                    className="me-2"
                    style={{
                      overflow: "hidden",
                      borderRadius: "50%",
                      objectFit: "cover",
                      backgroundColor: "#eaeaea",
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = avatar1;
                    }}
                  />
                </div>
                <div>
                  {`${item?.userProfile?.nickname}`} <br />
                  {item?.email}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: `${t("Campaign")}`,
        accessor: "CampaignName",
        filterable: false,
        sortable: false,
        thWidth: 200,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.campaign;
          return (
            item && (
              <div className="text-center" style={{ minWidth: 150 }}>
                <div>{item?.name}</div>
                <div className="text-primary">{item?.referral_code}</div>
              </div>
            )
          );
        },
      },
      {
        Header: `${t("Agency")}`,
        accessor: "AgencyName",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.agency;
          return (
            item && (
              <div className="text-center" style={{ minWidth: 150 }}>
                <div>{item?.agency_name}</div>
                <div className="text-primary">{item?.referral_code}</div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Branch Link"),
        accessor: "generated_link",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 250,
        Cell: (cell: any) => {
          const branch_link = cell?.value;

          return (
            branch_link && (
              <div
                className="cursor-pointer text-primary"
                style={{ maxWidth: "240px" }}
              >
                <CopyWrapper
                  contentCopy={branch_link}
                  style={{ minWidth: "70px" }}
                >
                  {truncate(branch_link, 60)}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Confirm Date"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstCoupon?.summary?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await agencyApi?.deleteAgency(id);
      if (response?.code === 200 && response?.message === "Success") {
        setItemToDelete(false);
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const onCloseQRCodeClick = () => {
    setPreviewQRCode(null);
  };

  const handleCloseModalBarDetail = () => {
    setItemToBarDetail(null);
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Coupon Issue")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Coupon Issue")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="couponIssue"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstCoupon?.summary?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Used")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstCoupon?.summary?.total_used || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Not-Used")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      lstCoupon?.summary?.total_not_used || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Expired")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstCoupon?.summary?.total_expired || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Keyword")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Keyword")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <div>
                          <LabelWrapper label={t("Store")} isShow={true}>
                            <DropdownAsyncBars
                              name="bar"
                              onChangeSelect={(event: any) => {
                                setBarSearch(event);
                              }}
                              isMulti={false}
                              placeholder={`${t("Select Store")}...`}
                              isShowIconCheck={false}
                              isAllOption={true}
                              listCheckedUsers={barSearch}
                              isClearable={false}
                            />
                          </LabelWrapper>
                        </div>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Users Used")} isShow={true}>
                          <DropdownAsyncUsers
                            name="bartender"
                            onChangeSelect={(event: any) => {
                              setUserUsedSearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select Bartender")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={userUsedSearch}
                            paramsTypeUsers={1}
                            isClearable={false}
                            defaultParams={{ is_active: 1 }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={COUPON_USE_STATUS_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_COUPON_USE_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Agency")} isShow={true}>
                          <DropdownAsyncAgency
                            name="agency_id"
                            onChangeSelect={(event: any) => {
                              setAgencySearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select Agency")}...`}
                            isShowIconCheck={false}
                            listCheckedUsers={agencySearch}
                            isAllOption={true}
                            isNotBelongToAgency={true}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Campaign")} isShow={true}>
                          <DropdownAsyncCampaign
                            name="campaign_id"
                            onChangeSelect={(event: any) =>
                              setCampaignSearch(event)
                            }
                            isMulti={false}
                            placeholder={`${t("Select Campaign")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedCampaign={campaignSearch}
                            isClearable={false}
                            isNotBelongToCampaign={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={
                        lstCoupon?.list?.data?.length
                          ? lstCoupon?.list?.data
                          : []
                      }
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={lstCoupon?.summary?.total}
                      customPageCount={Math.ceil(
                        Number(lstCoupon?.summary?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isCouponLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Agency Information")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {previewQRCode && (
          <ModalPreviewQRCode
            itemQRCode={previewQRCode}
            onCloseQRCodeClick={onCloseQRCodeClick}
          />
        )}

        {itemToBarDetail && (
          <Modal
            isOpen={!!itemToBarDetail}
            centered={true}
            size="xl"
            className="modal-fullscreen"
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModalBarDetail}>
              {itemToBarDetail?.title || ""}
            </ModalHeader>
            <ModalBody>
              <BarListDetail
                barID={itemToBarDetail?.id}
                setLinkImage={setLinkImage}
                // isShowDetail={true}
              />
            </ModalBody>
          </Modal>
        )}
      </div>
    </React.Fragment>
  );
};

export default CouponIssue;
